import classNames from "classnames";
import { partial } from "lodash";
import React, { useState } from "react";

export interface TooltipProps {
  label?: React.ReactNode;
  className?: string;
  contentClassname?: string;
  onClick: (e: React.MouseEvent<HTMLSpanElement>) => void;
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  label,
  className,
  contentClassname,
  onClick,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={classNames("tooltip", className)}
      onMouseOver={partial(setOpen, true)}
      onMouseLeave={partial(setOpen, false)}
      onClick={onClick}
    >
      {open && label && (
        <div className={classNames("tooltip-content", contentClassname)}>
          {label}
        </div>
      )}
      {children}
    </div>
  );
};
